export default "/images/layout-2.jpg?39f5fc8100fe7e10d4f0ee98a5829ab9";